import VentanaSimple from './ventana-simple';
export default VentanaSimple;